import React from "react";
import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, defaultBooleanField, mapAsOfSubtextDate } from "helpers/row-logic-helper";

import {
  shouldShowDeliveryPeriod,
  shouldShowListOfDocs,
  shouldShowReportingStartDate,
  shouldShowCashManagementReportingMisc,
  shouldShowWaiverStartDate,
  shouldShowWaiverEndDate
} from "./section-loan-cash-management-row-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  calculationPeriod: {
    isVisible: data => shouldShowDeliveryPeriod(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Delivery Period (days)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.cashManagementDeliveryPeriod"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  /*
   * highPriority: {
   *     cells: [
   *     {
   *         type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
   *         width: DEFAULT_WIDTH,
   *         label: "High Priority",
   *         Cell: tableSideColumnMapper
   *     },
   *     {
   *         type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
   *         map: data => defaultBooleanField(data, "covenants.highPriority"),
   *         Cell: tableSideColumnMapper
   *     }
   *     ]
   * },
   */

  listOfDocs: {
    isVisible: data => shouldShowListOfDocs(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "List Of Docs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => {
          const listOfDocs = defaultField(data, "covenants.cashManagementListOfDocs");
          const list = listOfDocs.sort((a, b) => (`${a.name}`).localeCompare(b.name)).map(x => (<p>{x.name}</p>));
          if (list.length > 0) {
            return list;
          }

          return [];
        },
        Cell: tableSideColumnMapper
      }
    ]
  },

  reportingStartDate: {
    isVisible: data => shouldShowReportingStartDate(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => mapAsOfSubtextDate(data, "covenants.reportStartDate"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  generalSubSection: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "General",
        Cell: tableSideColumnMapper,
        colSpan: 3
      }
    ]
  },

  cashManagementReportingMisc: {
    isVisible: data => shouldShowCashManagementReportingMisc(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Cash Management Reporting Misc.",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.cashManagementReportingMisc"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  reportingWaiver: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Waiver",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultBooleanField(data, "covenants.reportingWaiver", "Reporting has been waived", "Reporting has not been waived"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  reportingWaiverStartDate: {
    isVisible: data => shouldShowWaiverStartDate(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Waiver Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DATE,
        map: loan => defaultField(loan, "covenants.reportingWaiverStartDate"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  reportingWaiverEndDate: {
    isVisible: data => shouldShowWaiverEndDate(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Waiver End Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DATE,
        map: loan => defaultField(loan, "covenants.reportingWaiverEndDate"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
